import { Link } from 'react-router-dom';
import { articleList } from '@/utils/constants';

export default function ArticleSection() {
  return (
    <section id="article" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-4">
            Learning Center
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            Sugargoo Spreadsheet Guides &amp; SEO Resources
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            Dive deeper into Sugargoo with our comprehensive guides. Learn everything from product discovery to shipping optimization, reviews, coupons, and beginner tutorials.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {articleList.map((article) => (
            <Link
              key={article.slug}
              to={article.slug}
              className="group relative overflow-hidden rounded-lg bg-background-100 cursor-pointer transition-all duration-300 hover:scale-[1.02] flex flex-col"
            >
              <div className="relative w-full h-44 md:h-48 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.imageAlt}
                  className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="inline-block px-2.5 py-0.5 rounded-full bg-background-50/90 backdrop-blur-sm text-xs font-medium text-foreground-700">
                    {article.category}
                  </span>
                </div>
              </div>
              <div className="p-5 flex flex-col flex-1">
                <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-xs text-foreground-600 leading-relaxed mb-3 flex-1 line-clamp-2">
                  {article.description.replace(/<[^>]*>/g, '')}
                </p>
                <div className="flex items-center justify-between">
                  <span className="text-xs text-foreground-500">{article.readTime}</span>
                  <span className="inline-flex items-center gap-1 text-xs font-medium text-primary-600 whitespace-nowrap">
                    Read More
                    <span className="w-3 h-3 flex items-center justify-center">
                      <i className="ri-arrow-right-line text-xs"></i>
                    </span>
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}